import { render, staticRenderFns } from "./allowed.vue?vue&type=template&id=3bd7cdbb&"
import script from "./allowed.vue?vue&type=script&lang=js&"
export * from "./allowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports